import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "../../../store/types/RootState";
import {propertyFormModalInitialState} from "../constants/property_form_modal_initial_state";
import {propertyOneClickLeadModalInitialState} from "../constants/property_one_click_lead_modal_initial_state";
import {propertyPhoneModalInitialState} from "../constants/property_phone_modal_initiial_state";
import {IPropertyState} from "../types/IPropertyState";

export const propertySlice = createSlice({
    name: "property",
    initialState: {
        formModal: propertyFormModalInitialState,
        oneClickLeadModal: propertyOneClickLeadModalInitialState,
        phoneModal: propertyPhoneModalInitialState
    } as IPropertyState,
    reducers: {
        openPropertyFormModal: (state, action: PayloadAction<Omit<IPropertyState["formModal"], "isOpen">>) => {
            state.formModal = {...action.payload, isOpen: true};
        },
        closePropertyFormModal: (state) => {
            state.formModal = propertyFormModalInitialState;
        },
        openPropertyOneClickLeadModal: (state, action: PayloadAction<Omit<IPropertyState["oneClickLeadModal"], "isOpen">>) => {
            state.oneClickLeadModal = {...action.payload, isOpen: true};
        },
        closePropertyOneClickLeadModal: (state) => {
            state.oneClickLeadModal = propertyOneClickLeadModalInitialState;
        },
        openPropertyPhoneModal: (state, action: PayloadAction<Omit<IPropertyState["phoneModal"], "isOpen">>) => {
            state.phoneModal = {...action.payload, isOpen: true};
        },
        closePropertyPhoneModal: (state) => {
            state.phoneModal = propertyPhoneModalInitialState;
        }
    }
});

// Modals
export const {openPropertyFormModal, closePropertyFormModal} = propertySlice.actions;
export const selectPropertyFormModal = (state: RootState) => state.property.formModal;

export const {openPropertyOneClickLeadModal, closePropertyOneClickLeadModal} = propertySlice.actions;
export const selectPropertyOneClickLeadModal = (state: RootState) => state.property.oneClickLeadModal;

export const {openPropertyPhoneModal, closePropertyPhoneModal} = propertySlice.actions;
export const selectPropertyPhoneModal = (state: RootState) => state.property.phoneModal;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "../../../store/types/RootState";
import {propertyFormModalInitialState} from "../constants/property_form_modal_initial_state";
import {propertyOneClickLeadModalInitialState} from "../constants/property_one_click_lead_modal_initial_state";
import {propertyPhoneModalInitialState} from "../constants/property_phone_modal_initiial_state";
import {IPropertyState} from "../types/IPropertyState";

export const propertySlice = createSlice({
    name: "property",
    initialState: {
        formModal: propertyFormModalInitialState,
        oneClickLeadModal: propertyOneClickLeadModalInitialState,
        phoneModal: propertyPhoneModalInitialState
    } as IPropertyState,
    reducers: {
        openPropertyFormModal: (state, action: PayloadAction<Omit<IPropertyState["formModal"], "isOpen">>) => {
            state.formModal = {...action.payload, isOpen: true};
        },
        closePropertyFormModal: (state) => {
            state.formModal = propertyFormModalInitialState;
        },
        openPropertyOneClickLeadModal: (state, action: PayloadAction<Omit<IPropertyState["oneClickLeadModal"], "isOpen">>) => {
            state.oneClickLeadModal = {...action.payload, isOpen: true};
        },
        closePropertyOneClickLeadModal: (state) => {
            state.oneClickLeadModal = propertyOneClickLeadModalInitialState;
        },
        openPropertyPhoneModal: (state, action: PayloadAction<Omit<IPropertyState["phoneModal"], "isOpen">>) => {
            state.phoneModal = {...action.payload, isOpen: true};
        },
        closePropertyPhoneModal: (state) => {
            state.phoneModal = propertyPhoneModalInitialState;
        }
    }
});

// Modals
export const {openPropertyFormModal, closePropertyFormModal} = propertySlice.actions;
export const selectPropertyFormModal = (state: RootState) => state.property.formModal;

export const {openPropertyOneClickLeadModal, closePropertyOneClickLeadModal} = propertySlice.actions;
export const selectPropertyOneClickLeadModal = (state: RootState) => state.property.oneClickLeadModal;

export const {openPropertyPhoneModal, closePropertyPhoneModal} = propertySlice.actions;
export const selectPropertyPhoneModal = (state: RootState) => state.property.phoneModal;
